export const standart = [
  {
    keys: [
      { icon: 'arrow-left', special: 'left', span: 1 },
      { icon: 'arrow-right', special: 'right', span: 1 },
      { icon: 'input', span: 11, focusable: false },
      { icon: 'delete', special: 'delete', span: 2 },
    ],
  },
  {
    keys: [
      { character: 'ЯЗЫК', alt: 'ЯЗЫК', special: 'lang', span: 2 },
      { character: '1', alt: '1', span: 1 },
      { character: '2', alt: '2', span: 1 },
      { character: '3', alt: '3', span: 1 },
      { character: '4', alt: '4', span: 1 },
      { character: '5', alt: '5', span: 1 },
      { character: '6', alt: '6', span: 1 },
      { character: '7', alt: '7', span: 1 },
      { character: '8', alt: '8', span: 1 },
      { character: '9', alt: '9', span: 1 },
      { character: '0', alt: '0', span: 1 },
      { character: '_', alt: '-', span: 1 },
      { character: 'SHIFT', span: 2, special: 'shift' },
    ],
  },
  {
    keys: [
      { character: 'й', shift: 'Й', alt: '!', span: 1 },
      { character: 'ц', shift: 'Ц', alt: '@', span: 1 },
      { character: 'у', shift: 'У', alt: '#', span: 1 },
      { character: 'к', shift: 'К', alt: '$', span: 1 },
      { character: 'е', shift: 'Е', alt: '%', span: 1 },
      { character: 'н', shift: 'Н', alt: '^', span: 1, focused: true },
      { character: 'г', shift: 'Г', alt: '&', span: 1 },
      { character: 'ш', shift: 'Ш', alt: '*', span: 1 },
      { character: 'щ', shift: 'Щ', alt: '(', span: 1 },
      { character: 'з', shift: 'З', alt: ')', span: 1 },
      { character: 'х', shift: 'Х', alt: '_', span: 1 },
      { character: 'ъ', shift: 'Ъ', alt: '=', span: 1 },
    ],
  },
  {
    keys: [
      { character: 'ф', shift: 'Ф', alt: '?', span: 1 },
      { character: 'ы', shift: 'Ы', alt: '<', span: 1 },
      { character: 'в', shift: 'В', alt: '>', span: 1 },
      { character: 'а', shift: 'А', alt: '{', span: 1 },
      { character: 'п', shift: 'П', alt: '}', span: 1 },
      { character: 'р', shift: 'Р', alt: '\\', span: 1 },
      { character: 'о', shift: 'О', alt: '|', span: 1 },
      { character: 'л', shift: 'Л', alt: '/', span: 1 },
      { character: 'д', shift: 'Д', alt: '`', span: 1 },
      { character: 'ж', shift: 'Ж', alt: '~', span: 1 },
      { character: 'э', shift: 'Э', alt: '"', span: 1 },
    ],
  },
  {
    keys: [
      { character: 'я', shift: 'Я', alt: ':', span: 1 },
      { character: 'ч', shift: 'Ч', alt: ';', span: 1 },
      { character: 'с', shift: 'С', alt: '№', span: 1 },
      { character: 'м', shift: 'М', alt: '₴', span: 1 },
      { character: 'и', shift: 'И', alt: '£', span: 1 },
      { character: 'т', shift: 'Т', alt: '√', span: 1 },
      { character: 'ь', shift: 'Ь', alt: '≠', span: 1 },
      { character: 'б', shift: 'Б', alt: '´', span: 1 },
      { character: 'ю', shift: 'Ю', alt: '€', span: 1 },
    ],
  },
  {
    keys: [
      { character: '=/+', alt: 'abc', span: 1, special: 'alt' },
      { character: 'ПРОБЕЛ', alt: 'ПРОБЕЛ', special: 'space', span: 4 },
      { character: '.', alt: ',', span: 1 },
      { character: '-', alt: '-', span: 1 },
    ],
  },
];

export const noEmbeddedInput = [
  {
    keys: [
      { icon: 'arrow-left', special: 'left', span: 1 },
      { icon: 'arrow-right', special: 'right', span: 1 },
      { character: '1', alt: '1', span: 1 },
      { character: '2', alt: '2', span: 1 },
      { character: '3', alt: '3', span: 1 },
      { character: '4', alt: '4', span: 1 },
      { character: '5', alt: '5', span: 1 },
      { character: '6', alt: '6', span: 1 },
      { character: '7', alt: '7', span: 1 },
      { character: '8', alt: '8', span: 1 },
      { character: '9', alt: '9', span: 1 },
      { character: '0', alt: '0', span: 1 },
      { character: '_', alt: '-', span: 1 },
      { icon: 'delete', special: 'delete', span: 2 },
    ],
  },
  {
    keys: [
      { character: 'ЯЗЫК', alt: 'ЯЗЫК', special: 'lang', span: 2 },
      { character: 'й', shift: 'Й', alt: '!', span: 1 },
      { character: 'ц', shift: 'Ц', alt: '@', span: 1 },
      { character: 'у', shift: 'У', alt: '#', span: 1 },
      { character: 'к', shift: 'К', alt: '$', span: 1 },
      { character: 'е', shift: 'Е', alt: '%', span: 1 },
      { character: 'н', shift: 'Н', alt: '^', span: 1, focused: true },
      { character: 'г', shift: 'Г', alt: '&', span: 1 },
      { character: 'ш', shift: 'Ш', alt: '*', span: 1 },
      { character: 'щ', shift: 'Щ', alt: '(', span: 1 },
      { character: 'з', shift: 'З', alt: ')', span: 1 },
      { character: 'х', shift: 'Х', alt: '_', span: 1 },
      { character: 'ъ', shift: 'Ъ', alt: '=', span: 1 },
      { character: 'SHIFT', special: 'shift', span: 2 },
    ],
  },
  {
    keys: [
      { character: 'ф', shift: 'Ф', alt: '?', span: 1 },
      { character: 'ы', shift: 'Ы', alt: '<', span: 1 },
      { character: 'в', shift: 'В', alt: '>', span: 1 },
      { character: 'а', shift: 'А', alt: '{', span: 1 },
      { character: 'п', shift: 'П', alt: '}', span: 1 },
      { character: 'р', shift: 'Р', alt: '\\', span: 1 },
      { character: 'о', shift: 'О', alt: '|', span: 1 },
      { character: 'л', shift: 'Л', alt: '/', span: 1 },
      { character: 'д', shift: 'Д', alt: '`', span: 1 },
      { character: 'ж', shift: 'Ж', alt: '~', span: 1 },
      { character: 'э', shift: 'Э', alt: '"', span: 1 },
    ],
  },
  {
    keys: [
      { character: 'я', shift: 'Я', alt: ':', span: 1 },
      { character: 'ч', shift: 'Ч', alt: ';', span: 1 },
      { character: 'с', shift: 'С', alt: '№', span: 1 },
      { character: 'м', shift: 'М', alt: '₴', span: 1 },
      { character: 'и', shift: 'И', alt: '£', span: 1 },
      { character: 'т', shift: 'Т', alt: '√', span: 1 },
      { character: 'ь', shift: 'Ь', alt: '≠', span: 1 },
      { character: 'б', shift: 'Б', alt: '´', span: 1 },
      { character: 'ю', shift: 'Ю', alt: '€', span: 1 },
    ],
  },
  {
    keys: [
      { character: '=/+', alt: 'abc', span: 1, special: 'alt' },
      { character: 'ПРОБЕЛ', alt: 'ПРОБЕЛ', special: 'space', span: 4 },
      { character: '.', alt: ',', span: 1 },
      { character: '-', alt: '-', span: 1 },
    ],
  },
];

export const email = [
  {
    keys: [
      { icon: 'arrow-left', special: 'left', span: 1 },
      { icon: 'arrow-right', special: 'right', span: 1 },
      { character: '1', alt: '1', span: 1 },
      { character: '2', alt: '2', span: 1 },
      { character: '3', alt: '3', span: 1 },
      { character: '4', alt: '4', span: 1 },
      { character: '5', alt: '5', span: 1 },
      { character: '6', alt: '6', span: 1 },
      { character: '7', alt: '7', span: 1 },
      { character: '8', alt: '8', span: 1 },
      { character: '9', alt: '9', span: 1 },
      { character: '0', alt: '0', span: 1 },
      { character: '_', alt: '-', span: 1 },
      { icon: 'delete', special: 'delete', span: 2 },
    ],
  },
  {
    keys: [
      { character: 'ЯЗЫК', alt: 'ЯЗЫК', special: 'lang', span: 2 },
      { character: 'й', shift: 'Й', alt: '!', span: 1 },
      { character: 'ц', shift: 'Ц', alt: '@', span: 1 },
      { character: 'у', shift: 'У', alt: '#', span: 1 },
      { character: 'к', shift: 'К', alt: '$', span: 1 },
      { character: 'е', shift: 'Е', alt: '%', span: 1 },
      { character: 'н', shift: 'Н', alt: '^', span: 1, focused: true },
      { character: 'г', shift: 'Г', alt: '&', span: 1 },
      { character: 'ш', shift: 'Ш', alt: '*', span: 1 },
      { character: 'щ', shift: 'Щ', alt: '(', span: 1 },
      { character: 'з', shift: 'З', alt: ')', span: 1 },
      { character: 'х', shift: 'Х', alt: '_', span: 1 },
      { character: 'ъ', shift: 'Ъ', alt: '=', span: 1 },
      { character: 'SHIFT', special: 'shift', span: 2 },
    ],
  },
  {
    keys: [
      { character: 'ф', shift: 'Ф', alt: '?', span: 1 },
      { character: 'ы', shift: 'Ы', alt: '<', span: 1 },
      { character: 'в', shift: 'В', alt: '>', span: 1 },
      { character: 'а', shift: 'А', alt: '{', span: 1 },
      { character: 'п', shift: 'П', alt: '}', span: 1 },
      { character: 'р', shift: 'Р', alt: '\\', span: 1 },
      { character: 'о', shift: 'О', alt: '|', span: 1 },
      { character: 'л', shift: 'Л', alt: '/', span: 1 },
      { character: 'д', shift: 'Д', alt: '`', span: 1 },
      { character: 'ж', shift: 'Ж', alt: '~', span: 1 },
      { character: 'э', shift: 'Э', alt: '"', span: 1 },
    ],
  },
  {
    keys: [
      { character: 'я', shift: 'Я', alt: ':', span: 1 },
      { character: 'ч', shift: 'Ч', alt: ';', span: 1 },
      { character: 'с', shift: 'С', alt: '№', span: 1 },
      { character: 'м', shift: 'М', alt: '₴', span: 1 },
      { character: 'и', shift: 'И', alt: '£', span: 1 },
      { character: 'т', shift: 'Т', alt: '√', span: 1 },
      { character: 'ь', shift: 'Ь', alt: '≠', span: 1 },
      { character: 'б', shift: 'Б', alt: '´', span: 1 },
      { character: 'ю', shift: 'Ю', alt: '€', span: 1 },
    ],
  },
  {
    keys: [
      { character: '=/+', alt: 'abc', span: 1, special: 'alt' },
      { character: '@', alt: '@', span: 1 },
      { character: 'ПРОБЕЛ', alt: 'ПРОБЕЛ', special: 'space', span: 3 },
      { character: '.', alt: ',', span: 1 },
      { character: '-', alt: '-', span: 1 },
      { character: 'gmail.com', alt: 'gmail.com', smallFont: true, span: 2 },
    ],
  },
];

export default standart;
